import React from 'react';
import PropTypes from 'prop-types';
import MUICheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const Checkbox = ({ input, label, labelClasses, disabled, ...custom }) => (
  <FormControlLabel
    control={<MUICheckbox {...input} {...custom} checked={input.value} />}
    label={label}
    classes={labelClasses}
    disabled={disabled}
  />
);

Checkbox.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.bool,
  }).isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  labelClasses: PropTypes.object, // eslint-disable-line
};

export default Checkbox;
